if (!customElements.get('newsletter-dialog-trigger')) {
  customElements.define(
    'newsletter-dialog-trigger',
    class NewsletterDialogTrigger extends HTMLElement {
      timer = null;

      get modal() {
        return document.querySelector(this.dataset.modal);
      }

      get formId() {
        return this.modal?.querySelector('form')?.id;
      }

      connectedCallback() {
        if (this.isChallengePage()) return;

        if (this.isSubscriptionRedirect()) {
          this.showDialog();
          this.setCookie();
          this.publishAndCleanUrl();
          return;
        }

        this._unsubscribeModalHide = subscribe(
          'modal-hide',
          this.onModalHide.bind(this)
        );

        if (this.isDismissed()) return;

        const delay = parseInt(this.dataset.delay ?? '5000', 10);
        this.timer = setTimeout(() => this.showDialog(), delay);
      }

      disconnectedCallback() {
        clearTimeout(this.timer);
        this._unsubscribeModalHide?.();
      }

      isChallengePage() {
        return window.location.pathname.includes(SHOPIFY_SYSTEM_PATHS.CHALLENGE);
      }

      isSubscriptionRedirect() {
        const params = new URLSearchParams(window.location.search);
        return (
          params.get('customer_posted') === 'true' &&
          window.location.hash === `#${this.formId}`
        );
      }

      onModalHide({ id }) {
        if (id !== this.modal?.id) return;
        this.setCookie();
        this.publishAndCleanUrl();
      }

      publishAndCleanUrl() {
        publish('newsletter-activated', { formId: this.formId });
        this.cleanUrl();
      }

      showDialog() {
        const activeElement =
          document.activeElement instanceof HTMLElement
            ? document.activeElement
            : null;

        const opener =
          activeElement &&
          activeElement !== document.body &&
          activeElement !== this
            ? activeElement
            : null;

        this.modal?.show(opener);
      }

      isDismissed() {
        return document.cookie
          .split(';')
          .some((c) => c.trim().startsWith(`${this.dataset.cookieName}=`));
      }

      setCookie() {
        const days = parseInt(this.dataset.cookieDays ?? '30', 10);
        const expires = new Date(
          Date.now() + days * 24 * 60 * 60 * 1000
        ).toUTCString();
        document.cookie = `${this.dataset.cookieName}=1; expires=${expires}; path=/; SameSite=Lax`;
      }

      cleanUrl() {
        const url = new URL(window.location.href);
        url.searchParams.delete('customer_posted');
        if (this.formId && url.hash === `#${this.formId}`) {
          url.hash = '';
        }
        history.replaceState(null, '', url.toString().replace(/#$/, ''));
      }
    }
  );
}
